import React from 'react';

import Card from 'components/Card';
import Icon from 'components/Icon';
import Modal from 'components/Modal';
import ModalButton from 'components/ModalButton';
import ModalHeader from 'components/ModalHeader';

export default class UserGroupReviewModal extends React.Component {
    render() {
        let { closeModal, openSelectionModal, removeGroup, reviewCancel, reviewConfirm, show, user} = this.props;

        return (
            <Modal show={show}
                   className="user-group-review"
                   handleClose={closeModal.bind(this)}>
                <ModalHeader>
                    Review Groups
                </ModalHeader>
                <div role="button"
                     className="review-modal__add details-modal__info"
                     onClick={openSelectionModal.bind(this)}>
                    <Icon icon="plus" /> Add Group
                </div>
                <div className="cards">
                    {user.department && Object.keys(user.department).length > 0 ? (
                        <Card item={user.department}
                              onClick={removeGroup.bind(this, {})}
                              type="department--review" />
                    ) : null}
                </div>
                <div className="modal__buttons">
                    <ModalButton icon="check"
                                 onClick={reviewConfirm.bind(this)}
                                 text="Done" />
                    <ModalButton className="modal-button--cancel"
                                 icon="cancel"
                                 onClick={reviewCancel.bind(this)}
                                 text="Cancel" />
                </div>
            </Modal>
        )
    }
}



// WEBPACK FOOTER //
// ./src/containers/UsersPage/modals/UserGroupReviewModal.js